<template>
  <v-app fluid style="-webkit-app-region: drag">
    <v-tabs v-model="tab" height="59" color="#fff" flat class="firstBar fixed-bar ma-0 pa-0" app>
      <!-- <v-tabs-slider></v-tabs-slider> -->

      <!-- <div style="width: 470px;margin-left:10px;">
        <img src="../assets/logo.png" style="height: 3.1rem;
    -o-object-fit: contain;
    object-fit: contain;" alt="" srcset="">
       
      </div> -->
      <v-spacer></v-spacer>
      <v-tab href="#tab-1" class="tab" active-class="tab_color" color="#0482fb">
        Gestion
      </v-tab>

      <v-tab href="#tab-2" active-class="tab_color">
        Agenda
        <v-badge class="ml-10 shake " color="#0482fb" bordered overlap :content="`${callList.length + rdvList.length}`">
          <v-icon color="#0482fb" size="25">mdi-calendar</v-icon>
        </v-badge>
      </v-tab>

      <v-tab href="#tab-3" disabled active-class="tab_color">
        Rappel
        <v-badge class="ml-10  shake " color="error" bordered overlap content="0">
          <v-icon color="#0482fb" size="25">mdi-checkbox-marked-circle-plus-outline</v-icon>
        </v-badge>
      </v-tab>
      <v-spacer></v-spacer>
      <!-- <v-badge :content="messages" :value="messages" color="green" overlap>
        <div class="text-center">
          <v-menu v-model="menuCall" :close-on-content-click="false" offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-badge
                color="green"
                class="ml-10 mt-3 shake "
                bordered
                overlap
                :content="`${callList.length}`"
              >
                <v-btn icon v-bind="attrs" v-on="on" color="#0482fb">
                  <v-icon>mdi-phone</v-icon>
                </v-btn>
              </v-badge>
            </template>

            <v-card max-width="600" max-height="700">
              <v-toolbar fixed color="green white--text" dark>
                <v-toolbar-title>Listing des appels</v-toolbar-title>

                <v-spacer></v-spacer>
              </v-toolbar>

              <v-img
                v-if="callList == ''"
                src="@/assets/noPiority.png"
                max-height="200px"
                max-width="200px"
                alt="admin"
                class="mx-auto"
              />
              <v-list
                v-if="callList"
                class="pl-0 pt-20 "
                style=" overflow: hidden !important"
                shaped
              >
                <v-card flat link>
                  <template v-for="item in callList">
                    <v-list-item class="alertList" :key="item.reason">
                      <v-list-item-content>
                        <v-chip
                          :text-color="`${item.color}`"
                          color="#fff"
                          :to="`${item.link}`"
                          class="listLibele ml-0 pl-0"
                        >
                          {{ item.date }}{{ " - " }} {{ item.hour }}
                        </v-chip>
                        <v-list-item-subtitle
                          style="color:#000 word-wrap: break-word;"
                          v-html="
                            '<span >' +
                              item.file.name +
                              '</span>' +
                              '<br><br>Raison d\'appel : ' +
                              '<br> .' +
                              '<p>' +
                              item.reason +
                              '</p>'
                          "
                        ></v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                  </template>
                </v-card>
              </v-list>
            </v-card>
          </v-menu>
        </div>
      </v-badge> -->
      <!-- <v-badge :content="messages" :value="messages" color="green" overlap>
        <div class="text-center">
          <v-menu v-model="menuRdv" :close-on-content-click="false" offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-badge
                color="warning"
                class="ml-10 mt-3 shake "
                bordered
                overlap
                :content="`${rdvList.length}`"
              >
                <v-btn icon v-bind="attrs" v-on="on" color="#0482fb">
                  <v-icon>mdi-calendar-edit</v-icon>
                </v-btn>
              </v-badge>
            </template>

            <v-card max-width="600" max-height="700">
              <v-toolbar class="fixed-bar" color="warning white--text" dark>
                <v-toolbar-title>Listing des rendez-vous </v-toolbar-title>

                <v-spacer></v-spacer>
              </v-toolbar>
              <v-img
                v-if="rdvList == ''"
                src="@/assets/noPiority.png"
                max-height="200px"
                max-width="200px"
                alt="admin"
                class="mx-auto"
              />
              <v-list v-if="rdvList" class="pl-0 pt-20 " shaped>
                <template v-for="item in rdvList">
                  <v-list-item class="alertLists" :key="item.reason">
                    <v-list-item-content>
                      <v-chip
                        :text-color="`${item.color}`"
                        color="#fff"
                        :to="`${item.link}`"
                        class="listLibele ml-0 pl-0"
                      >
                        {{ item.date }}{{ " - " }} {{ item.hour }}
                      </v-chip>
                      <v-list-item-subtitle
                        style="word-wrap: break-word !important;"
                        v-html="
                          '<span >' +
                            item.file.name +
                            '</span>' +
                            '<br> .' +
                            item.reason
                        "
                      ></v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                </template>
              </v-list>
            </v-card>
          </v-menu>
        </div>
      </v-badge> -->
      <v-badge :content="messages" :value="messages" color="green" overlap>
        <div class="text-center">
          <v-menu v-model="menu" :close-on-content-click="false" offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-badge class="ml-10 mt-3 shake " bordered overlap color="error" :content="`${priority.length}`">
                <v-btn icon v-bind="attrs" v-on="on" color="#0482fb">
                  <v-icon>mdi-clock-alert-outline</v-icon>
                </v-btn>
              </v-badge>
            </template>

            <v-card max-width="600" max-height="700">
              <v-toolbar class="fixed-bar" fixed color="red white--text" dark>
                <v-toolbar-title>Alert / Rappel / Priorité</v-toolbar-title>

                <v-spacer></v-spacer>
              </v-toolbar>

              <v-list v-if="priority" class="pl-0 pt-20 " style=" overflow: hidden !important" shaped>
                <v-card flat class="ma-0" link>
                  <template v-for="item in priority">
                    <v-card :key="item.title" flat>
                      <div class="alertListe" style="">
                        <v-card class="d-flex justify-start mb-3 " flat>
                          <v-chip :text-color="`${item.color}`" color="#fff" :to="`${item.link}`" class="listLibele ml-0">
                            {{ item.type }}
                          </v-chip>
                        </v-card>
                        <p style="color:darkgrey; margin-left:10px;">
                          {{ item.message }}
                        </p>
                      </div>
                    </v-card>
                  </template>
                </v-card>
              </v-list>
              <v-img v-if="priority == ''" src="@/assets/noPiority.png" max-height="200px" max-width="200px" alt="admin"
                class="mx-auto" />
            </v-card>
          </v-menu>
        </div>
      </v-badge>
      <div class="mr-10 ml-15 mt-2 ">
        <v-text style="color: #5E5669;font-size:15px; font-weight: bold;">
          {{ profile.firstName }} {{ profile.lastName }} </v-text><br />
        <v-text style="color: #5E5669; font-size:12px;">{{
          profile.currentPosition
        }}</v-text>
      </div>

      <div class="text-center">
        <v-menu v-model="profilMenu" :close-on-content-click="false" :nudge-width="500" offset-y bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-avatar v-bind="attrs" v-on="on" size="45" class="ml-1 mr-10 mt-2" color="grey lighten-4">
              <v-img v-if="profile.idPicture" :src="profile.idPicture"></v-img>
              <v-icon v-else color="#0482fb"> mdi-account </v-icon>
            </v-avatar>
            <v-badge bordered bottom color="green" dot offset-x="-0" offset-y="15"></v-badge>
          </template>

          <v-card>
            <v-list>
              <v-list-item>
                <v-list-item-avatar>
                  <v-img v-if="profile.idPicture" :src="profile.idPicture"></v-img>
                  <v-icon v-else color="#0482fb"> mdi-account </v-icon>
                </v-list-item-avatar>

                <v-list-item-content>
                  <v-list-item-title>{{ profile.firstName }}
                    {{ profile.lastName }}</v-list-item-title>
                  <v-list-item-subtitle>{{
                    profile.currentPosition
                  }}</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-list>

            <v-divider></v-divider>

            <v-list>
              <v-list-item>
                <v-row style="justify-content: space-evenly; width: 100%">
                  <v-btn v-on:click="updateUserProfile = true" color="#fff" class="clickable textColor2 " dark
                    width="auto">
                    <v-icon class="mr-5">mdi-account-alert-outline</v-icon>
                    Modifier le profil
                  </v-btn>

                  <v-btn v-on:click="logoutMethods" color="#fff" class="clickable textColor4 white--text " dark
                    width="auto">
                    Se déconnecter<v-icon class="ml-5">mdi-power</v-icon>
                  </v-btn>
                </v-row>
              </v-list-item>
            </v-list>

            <v-card-actions>
              <h6 class="ml-5">V - 0.3.1 ( 21 / 07 / 2022 )</h6>
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-menu>
      </div>
    </v-tabs>

    <v-tabs-items v-model="tab">
      <v-tab-item style="    padding-bottom: 100px !important;" value="tab-1">
        <router-view></router-view>
      </v-tab-item>
      <v-tab-item style="height: 100%;" value="tab-2">
        <!-- <v-card class="illustrationCenter elevation-0">
          <v-img
            src="../assets/constructe.png"
            max-height="600"
            max-width="600"
            alt="logo"
          ></v-img>
        </v-card> -->
        <v-sheet height="64" class="headCalender fixed-bars">
          <v-toolbar class="mt-20 mb-20" flat>
            <h4 class="text-h4 pageTitle ">
              Agenda
            </h4>
            <v-divider class="mx-4" inset vertical></v-divider>
            <v-switch v-model="showAllFil" label="Personnel" color="#0482fb" @change="agendaListe"
              class="pt-5"></v-switch>
            <v-spacer></v-spacer>
          </v-toolbar>
          <v-toolbar flat>
            <v-btn outlined class="mr-4" color="grey darken-2" @click="setToday">
              Aujourdhui
            </v-btn>
            <v-btn fab text small color="grey darken-2" @click="prev">
              <v-icon small>
                mdi-chevron-left
              </v-icon>
            </v-btn>
            <v-btn fab text small color="grey darken-2" @click="next">
              <v-icon small>
                mdi-chevron-right
              </v-icon>
            </v-btn>
            <v-toolbar-title v-if="$refs.calendar">
              {{ $refs.calendar.title }}
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-menu bottom right>
              <template v-slot:activator="{ on, attrs }">
                <v-btn outlined color="#0482fb" v-bind="attrs" v-on="on">
                  <span>{{ typeToLabel[type] }}</span>
                  <v-icon right>
                    mdi-menu-down
                  </v-icon>
                </v-btn>
              </template>
              <v-list>
                <v-list-item @click="type = 'day'">
                  <v-list-item-title>Jours</v-list-item-title>
                </v-list-item>
                <v-list-item @click="type = 'week'">
                  <v-list-item-title>Semaine</v-list-item-title>
                </v-list-item>
                <v-list-item @click="type = 'month'">
                  <v-list-item-title>Mois</v-list-item-title>
                </v-list-item>
                <v-list-item @click="type = '4day'">
                  <v-list-item-title>4 Jours</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
            <v-btn class="white--text ml-5" color="success" pill @click="(addNewProgramme()), (editedIndex = -1)">
              <v-icon left> mdi-pencil </v-icon>
              Enregistrer un programme
            </v-btn>
          </v-toolbar>
        </v-sheet>
        <v-container fluid>
          <v-row class="fill-height">
            <v-col>
              <!-- {{ events }} -->
              <v-sheet height="78vh">
                <v-calendar ref="calendar" v-model="focus" color="#0482fb" class="white-text" text-color="#fff"
                  :events="events" locale="fr-FR" datePickerTintColor="#fff" :event-color="getEventColor" :type="type"
                  @click:event="showEvent" @click:more="viewDay" @click:date="viewDay" @change="updateRange">
                  <template v-slot:event="{ event }">
                    <!-- <div style="min-height: 60px !important;padding:10;">
                      <h4 v-html="event.name"></h4>
                      <h6>{{ event.name }}</h6>
                    </div> -->
                    <span v-html="event.name"></span>
                    <!-- <span v-html="event.name"></span>
                    {{ event.hour }} -->
                  </template>
                </v-calendar>
                <v-dialog v-model="appointmentAddDialog" max-width="1000px">
                  <v-card style="border-top: 10px solid #0482fb">
                    <v-card-title>
                      <span class="text-h5">{{ formTitle }}</span>
                    </v-card-title>
                    <v-card-text>
                      <v-container>
                        <v-row>
                          <v-col cols="4">
                            <v-select outlined v-model="agendaData.file" :items="prospectsNameList" attach
                              label="Nom raison social"></v-select>
                          </v-col>
                          <v-col cols="4">
                            <v-select outlined v-model="agendaData.assignTo" :items="userNameList" attach
                              label="Agent exécutant" multiple></v-select>
                          </v-col>
                          <v-col cols="4">
                            <v-select outlined v-model="agendaData.appointmetType" :items="ProgrammeType"
                              label="Type de programme"></v-select>
                          </v-col>
                          <v-col cols="6">
                            <v-text-field outlined color="#0482fb" v-model="agendaData.subject"
                              label="Objet "></v-text-field>
                          </v-col>
                          <v-col v-if="agendaData.appointmetType == 'Rendez-vous'" cols="6">
                            <v-text-field outlined color="#0482fb" v-model="agendaData.participants"
                              label="Ajouter les participants au rendez-vous"></v-text-field>
                          </v-col>
                          <v-col v-if="agendaData.appointmetType == 'Rendez-vous'" cols="6">
                            <v-combobox v-model="agendaData.emails" outlined chips clearable
                              label="Mail des participant du rendez-vous (Requis *)" multiple>
                              <template v-slot:selection="{ attrs, item, select, selected, }">
                                <v-chip v-bind="attrs" :input-value="selected" close @click="select"
                                  @click:close="remove(item)">
                                  <strong>{{ item }}</strong>&nbsp;
                                  <span>(participants)</span>
                                </v-chip>
                              </template>
                            </v-combobox>
                          </v-col>
                          <v-col cols="6">
                            <v-combobox v-model="agendaData.rememberMinutes" outlined :items="itemsData"
                              label="Durée rappels">
                              <template v-slot:selection="{
                                attrs,
                                item,
                                select,
                                selected,
                              }">
                                <v-chip type="number" v-bind="attrs" :input-value="selected" @click="select">
                                  <strong>{{ item }}</strong>&nbsp;
                                  <span>min</span>
                                </v-chip>
                              </template>
                            </v-combobox>
                          </v-col>
                          <v-col v-if="agendaData.location == 'Rendez-vous'" cols="6">
                            <v-text-field outlined color="#0482fb" v-model="agendaData.location"
                              label="Lieu rendez-vous"></v-text-field>
                          </v-col>
                          <v-col cols="6">
                            <v-text-field outlined color="#0482fb" v-model="agendaData.date" type="date"
                              label="Date Programme"></v-text-field>
                          </v-col>
                          <v-col cols="6">
                            <v-text-field outlined color="#0482fb" v-model="agendaData.startPeriod" type="time"
                              label="Heure Programme"></v-text-field>
                          </v-col>
                          <v-col v-if="agendaData.appointmetType == 'Rendez-vous'" cols="6">
                            <v-text-field outlined color="#0482fb" v-model="agendaData.endPeriod" type="time"
                              label="Heure de clôture"></v-text-field>
                          </v-col>
                          <v-col cols="12">
                            <quill-editor ref="editor" v-model="agendaData.reason" label="Motifs programme" class="mt-5"
                              :options="editorOption" />
                          </v-col>

                          <v-col cols="12">
                            <v-select outlined v-model="agendaData.done" :items="this.itemsDone" attach chips
                              label="Programme effectué ?"></v-select>
                          </v-col>
                          <!-- <v-col cols="12">
                            <v-text-field class="pa-0" color="#0482fb" v-model="agendaData.endPeriod" type="color"
                              label="Heure de clôture"></v-text-field>
                            <v-color-picker
                              class="ma-2"
                              show-swatches
                              swatches-max-height="300px"
                            ></v-color-picker>
                          </v-col> -->
                          <v-col cols="12">
                            <quill-editor ref="editor" v-if="agendaData.done" v-model="agendaData.returnObservation"
                              label="Retour Programme" class="mt-5" :options="editorOption" />
                          </v-col>
                        </v-row>
                      </v-container>
                    </v-card-text>

                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn class="white--text ma-2" :disabled="loading" color="error darken-1" text
                        @click="closeAppointment">
                        Fermer
                      </v-btn>
                      <v-btn class="white--text ma-2" :loading="loading ? '#0482fb' : null" color="success darken-1"
                        @click="saveAppointment">
                        Enregistrer
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
                <v-menu v-model="selectedOpen" :close-on-content-click="false" :activator="selectedElement" offset-x>
                  <v-card color="grey lighten-4" min-width="350px" flat>
                    <v-toolbar :color="selectedEvent.color" dark>
                      <v-toolbar-title v-html="selectedEvent.subject"></v-toolbar-title>
                      <v-spacer></v-spacer>

                      <v-btn icon>
                        <v-icon>mdi-dots-vertical</v-icon>
                      </v-btn>
                    </v-toolbar>
                    <v-card-text>
                      <v-list-item :text-color="`${selectedEvent.color}`" class="listLibele ml-0 pl-0 mb-50">
                        {{ "Lieu rendez-vous " }}
                        {{ selectedEvent.location }} {{
                          selectedEvent.date
                        }}{{ " - " }}
                        {{ selectedEvent.hour }}
                      </v-list-item>
                      <!-- {{ selectedEvent }} -->
                      <v-list-item-content>
                        <!-- <v-chip
                          :text-color="`${selectedEvent.color}`"
                          :to="`${selectedEvent.link}`"
                          class="listLibele ml-0 pl-5 mb-20"
                        >
                         
                        </v-chip> -->

                        <v-list-item-subtitle style="word-wrap: break-word !important;"
                          v-html="selectedEvent.name"></v-list-item-subtitle>
                      </v-list-item-content>
                      <!-- <span v-html="selectedEvent.details"> </span> -->
                    </v-card-text>
                    <v-card-actions>
                      <v-btn text color="secondary" @click="selectedOpen = false">
                        Retour
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </v-menu>
              </v-sheet>
            </v-col>
          </v-row>
        </v-container>
      </v-tab-item>
      <v-tab-item value="tab-3">
        <v-card class="illustrationCenter elevation-0">
          <v-img src="../assets/constructe.png" max-height="600" max-width="600" alt="logo"></v-img>
        </v-card>
      </v-tab-item>
    </v-tabs-items>
    <v-navigation-drawer v-model="drawer" :mini-variant.sync="mini" permanent left class="leftBar" app>
      <!-- <v-app-bar elevation="0" dark class=" textColor3 ">
        <v-list-item>
          <v-img
            v-if="!mini"
            src="@/assets/logo.jpg"
            max-height="110px"
            max-width="110px"
            alt="admin"
            class="mx-auto"
          />
        </v-list-item>
      </v-app-bar> -->
      <v-list-item-action>
        <!-- <v-btn @click.stop="mini = !mini" class="toggleBtn white--text ma-2" icon>
          <v-icon>{{ iconRow }}</v-icon>
        </v-btn> -->
        <div style="width: 100%;margin-left:10px;">
        <img src="../assets/logo.png" style="height: 3.1rem;
    -o-object-fit: contain;
    object-fit: contain;" alt="" srcset="">
       
      </div>
      </v-list-item-action>
      <v-list shaped class="clickable">
        <template v-for="(item, i) in items">
          <div v-if="item.isAdmin === isAdmin || item.isUser === isUser" :key="i" :disabled="item.disable">
            <v-list-group v-if="item.children" v-model="item.model" :prepend-icon="iconRow" append-icon class="textColor"
              active-class="textColor-active">
              <template v-slot:activator>
                <v-list-item-content>
                  <v-list-item-title>
                    {{ item.text }}
                  </v-list-item-title>
                </v-list-item-content>
              </template>
              <v-list-item v-for="(child, i) in item.children" :key="i" route :to="child.route" class="textColor"
                active-class="textColor-active">
                <v-list-item-action v-if="child.icon">
                  <v-icon>{{ child.icon }}</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-title>
                    {{ child.text }}
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list-group>
            <v-list-item v-else class="textColor" active-class="textColor-active" route :to="item.route">
              <v-list-item-action>
                <v-icon>{{ item.icon }}</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>
                  {{ item.text }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </div>
        </template>
      </v-list>

      <!-- <v-btn class="white--text ma-2"
        v-on:click="logoutMethods"
        color="#fff"
        class="clickable textColor2 white--tex mb-0 ml-0 "
        style="margin-top:80% ; width:10%"
        dark
        width="auto"
      >
        <v-icon large>mdi-power</v-icon>
      </v-btn> -->
    </v-navigation-drawer>
    <v-footer class="footer degrader" style="height: 60px;left: 255px;right: 0px;bottom: 0px;" app height="60">
      <!-- <div style="width: 250px;margin-left:10px;"></div> -->
      <!-- <v-spacer></v-spacer> -->
      <span class="hidden-sm-and-down" width="200px"><b style="color:#fff; font-size:25px;">DAYO - </b>
        <b style="color:#fff ;font-size:25px;">IARD</b><b style="color:#fff ;font-size:25px;"> BENIN</b></span>
      <v-spacer></v-spacer>
    </v-footer>
    <v-btn v-scroll="onScroll" bottom color="#fff" dark fab fixed right @click="toTop"
      class="clickable white--text ma-2 mb-200  ">
      <v-icon color="#0482fb" size="50">mdi-chevron-up</v-icon>
    </v-btn>
    <!-- <v-card id="create">
      <v-speed-dial
        v-model="fab"
        bottom
        right
        :direction="left"
        transition="slide - y - reverse - transition"
      >
        <template v-slot:activator>
          <v-btn class="white--text ma-2" v-model="fab" color="blue darken-2" dark fab>
            <v-icon v-if="fab">
              mdi-close
            </v-icon>
            <v-icon v-else>
              mdi-account-circle
            </v-icon>
          </v-btn>
        </template>
        <v-btn class="white--text ma-2" fab dark small color="green">
          <v-icon>mdi-pencil</v-icon>
        </v-btn>
        <v-btn class="white--text ma-2" fab dark small color="indigo">
          <v-icon>mdi-plus</v-icon>
        </v-btn>
        <v-btn class="white--text ma-2" fab dark small color="red">
          <v-icon>mdi-delete</v-icon>
        </v-btn>
      </v-speed-dial>
    </v-card> -->
    <v-row justify="center">
      <v-dialog v-model="updateUserProfile" max-width="500px">
        <v-card style="border-top:10px solid #0482fb">
          <v-card-title>
            <span class="text-h5">Modifier les information de l'utilisateur</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12" sm="12" md="12">
                  <v-row>
                    <v-img elevation="1" style="border: 0.5px solid #0482fb; padding:20px; border-radius:20px;"
                      class="mr-4" v-if="profile.idPicture" :src="profile.idPicture"></v-img>
                    <v-icon style="border: 0.5px solid #0482fb; padding:20px; border-radius:20px; " v-else elevation="1"
                      class="mr-4" color="#0482fb">
                      mdi-account
                    </v-icon>
                    <v-file-input small-chips prepend-icon="mdi-camera" truncate-length="50"
                      v-model="idPicture"></v-file-input>
                  </v-row>
                </v-col>
                <v-col cols="12" sm="6" md="6">
                  <v-text-field outlined label="Nom complet*" v-model="profile.firstName" required></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="6">
                  <v-text-field outlined label="Prenom complet*" v-model="profile.lastName" required></v-text-field>
                </v-col>
                <v-col cols="12" sm="12" md="12">
                  <v-text-field outlined label="Mail*" v-model="profile.email" required></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="6">
                  <v-text-field outlined label="Téléphone*" v-model="profile.phone" required></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="6">
                  <v-text-field outlined label="Post Actuel*" v-model="profile.currentPosition" required></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="6">
                  <v-text-field outlined label="Mots de passe Actuels*" v-model="profile.oldPassword"
                    required></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="6">
                  <v-text-field outlined label="nouveau mots de passe*" v-model="profile.passwords"
                    required></v-text-field>
                </v-col>
              </v-row>
            </v-container>
            <small>*Indique les informations requises</small>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn class="white--text ma-2" color="error" text @click="dialog = false">
              Fermer
            </v-btn>
            <v-btn class="white--text ma-2" color="success" @click="onUpdatedUserProfile">
              Enregistrer
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
  </v-app>
</template>

<script>
//import * as auth from '../services/auth_service'
import { mapActions, mapGetters } from "vuex";
import { defaultMethods, messages } from "@/utils/data";
import { quillEditor } from "vue-quill-editor";
import "quill/dist/quill.snow.css";
import { logout } from "@/api/auth";
import { updateUsers, addCall, addAppointment } from "@/api/user";

export default {
  components: { quillEditor },
  props: {
    rdvRequest: {
      type: Object,
      required: true,
    },
    source: String,
  },
  data: () => ({
    drawer: null,
    messages: 0,
    mini: false,
    tab: null,
    showPriority: true,
    showcall: false,
    showAllFil: false,
    showRdv: false,
    fab: false,
    agendaData: [],
    itemsData: [15, 30, 60, 120],
    itemsDone: [
      {
        text: "Oui",
        value: true,
      },
      {
        text: "Non",
        value: false,
      },
    ],
    ProgrammeType: ["Appel", "Rendez-vous"],
    appointmentAddDialog: false,
    appointmentModal: [],
    iconRow: "mdi-arrow-down-drop-circle-outline",
    menu: "",
    SizeDrawers: "0px",
    profilMenu: false,
    updateUserProfile: false,
    selected: "",

    //calendrier data
    focus: "",
    type: "month",
    typeToLabel: {
      month: "Mois",
      week: "Semaine",
      day: "Jours",
      "4day": "4 Jours",
    },
    selectedEvent: {},
    selectedElement: null,
    selectedOpen: false,
    events: [],
    newEvents: [],
    colors: [
      "#9e2a2b",
      "indigo",
      "deep-purple",
      "cyan",
      "green",
      "orange",
      "grey darken-1",
    ],
    names: [
      "Meeting",
      "Holiday",
      "PTO",
      "Travel",
      "Event",
      "Birthday",
      "Conference",
      "Party",
    ],
    //end
    Alerts: [
      {
        action: "",
        headline: "",
        subtitle: `En cours de développement`,
        title: "",
      },
      {
        action: "",
        headline: "",
        subtitle: `En cours de développement`,
        title: "",
      },
    ],

    items: [
      {
        icon: "mdi-home",
        text: "Accueil",
        route: "/",
        isAdmin: true,
        isUser: true,
      },
      {
        icon: "mdi-card-account-details-outline",
        text: "Prospection",
        route: "/prospection",
        isUser: true,
      },
      {
        icon: "mdi-widgets-outline",
        text: "Cotation",
        route: "/cotation",
        isUser: true,
      },
      {
        icon: "mdi-finance",
        text: "Projet",
        route: "/production",
        isUser: true,
      },
      {
        icon: "mdi-file-sign",
        text: "Emission",
        route: "/contrat",
        isUser: true,
      },
      {
        icon: "mdi-file-sign",
        text: "Reversement",
        route: "/reversement",
        isUser: true,
      },
      {
        icon: "mdi-account-cash-outline",
        text: "Commission",
        route: "/Encaissement",
        isUser: true,
      },
      {
        icon: "mdi-cash-multiple",
        text: "Paiement",
        route: "/payement",
        isUser: true,
      },
      {
        icon: "mdi-cash-multiple",
        text: "Rapprochement",
        route: "/rapprochement",
        isUser: true,
      },
      // {
      //   icon: "mdi-receipt-text-check-outline",
      //   text: "Editer Facture",
      //   route: "/facture",
      //   isUser: true,
      // },
      {
        icon: "mdi-bell-alert-outline",
        text: "Avis échéance",
        route: "/echeance",
        isUser: true,
      },
      {
        icon: "mdi-cellphone-check",
        text: "Déclaration Mobile",
        route: "/mobile",
        isUser: true,
        // isAdmin: true,pm run dev
      },
      {
        icon: "mdi-ambulance",
        text: "Sinistre",
        route: "/sinistre",
        isUser: true,
        // isAdmin: true,pm run dev
      },
      {
        icon: "mdi-clipboard-account-outline",
        text: "Inventaire",
        route: "/inventaire",
        isUser: true,

        // isAdmin: true,
      },
      {
        icon: "mdi-archive-arrow-down-outline",
        text: "Courriers",
        route: "/courier",
        isUser: true,
      },
      {
        icon: "mdi-chart-waterfall",
        text: "Statistiques",
        route: "/chart",
        isUser: true,
      },
      {
        icon: "mdi-shield-account",
        text: "Management",
        route: "/management",
        isAdmin: true,
      },
    ],
  }),
  watch: {
    Files() {

      this.prospectsNameList = defaultMethods.getNameList(this.Files.docs).sort();
      // alert(JSON.stringify(this.prospectsNameList))

    },
    Users() {
      this.userNameList = defaultMethods.getNameList(this.Users.docs);
      // alert(JSON.stringify(this.userNameList))
    },
  },
  computed: {
    ...mapGetters([
      "UserProfile",
      "AdminProfile",
      "priority",
      "callList",
      "rdvList",
      "Agenda",
      "Files",
      "Users"

    ]),
    isAdmin() {
      if (localStorage.getItem("admin-token")) return true;
      return false;
    },
    isUser() {
      if (localStorage.getItem("user-token")) return true;
      return false;
    },
    profile() {
      if (this.UserProfile && this.UserProfile._id) return this.UserProfile;
      else return this.AdminProfile;
    },
  },
  mounted() {
    if (this.isUser) {
      this.getUserProfile();
    }
    document.body.style.zoom = "80%";
    if (this.isAdmin) {
      this.getAdminProfile();
    }
    this.agendaListe();
    this.initpriority();
  },
  methods: {
    ...mapActions([
      "getAdminProfile",
      "getUserProfile",
      "getPriority",
      "getCallList",
      "getRdvList",
      "getAgenda",
      "getFiles",
      "getUsers"
    ]),
    viewDay({ date }) {
      this.focus = date;
      this.type = "day";
    },
    getEventColor(event) {
      return event.color;
    },
    setToday() {
      this.focus = "";
    },
    prev() {
      this.$refs.calendar.prev();
    },
    next() {
      this.$refs.calendar.next();
    },
    showEvent({ nativeEvent, event }) {
      const open = () => {
        this.selectedEvent = event;
        this.selectedElement = nativeEvent.target;
        requestAnimationFrame(() =>
          requestAnimationFrame(() => (this.selectedOpen = true))
        );
      };

      if (this.selectedOpen) {
        this.selectedOpen = false;
        requestAnimationFrame(() => requestAnimationFrame(() => open()));
      } else {
        open();
      }

      nativeEvent.stopPropagation();
    },
    async saveAppointment() {
      this.loading = true;
      try {

        if (this.agendaData.appointmetType == "Appel") {

          const schema = {
            assignTo: defaultMethods.getItemsId(
              this.Users.docs,
              this.agendaData.assignTo
            ),
            reason: this.agendaData.reason,
            participants: this.agendaData.participants,
            // startPeriod: this.agendaData.startPeriod,
            // endPeriod: this.agendaData.startPeriod,
            date: this.agendaData.date,
            hour: this.agendaData.startPeriod,
            location: this.agendaData.location,
            returnObservation: this.agendaData.returnObservation,
            done: this.agendaData.done,
          };

          // add
          await addCall({
            schema,
            id: defaultMethods.getItemId(
              this.Files.docs,
              this.agendaData.file
            ),
          });
          defaultMethods.dispatchSuccess(
            this.$store,
            messages.createdSuccessfully("Votre appel"))


        } else {
          const schema = {
            assignTo: defaultMethods.getItemsId(
              this.Users.docs,
              this.agendaData.assignTo
            ),
            subject: this.agendaData.subject,
            rememberMinutes: this.agendaData.rememberMinutes,
            emails: this.agendaData.emails,
            reason: this.agendaData.reason,
            participants: this.agendaData.participants,
            startPeriod: this.agendaData.startPeriod,
            endPeriod: this.agendaData.endPeriod,
            date: this.agendaData.date,
            hour: this.agendaData.startPeriod,
            location: this.agendaData.location,
            returnObservation: this.agendaData.returnObservation,
            done: this.agendaData.done,
          };
          await addAppointment({
            schema,
            id: defaultMethods.getItemId(
              this.Files.docs,
              this.agendaData.file
            ),
          });
          defaultMethods.dispatchSuccess(
            this.$store,
            messages.createdSuccessfully("Rendez-vous")
          );
        }

        this.appointmentAddDialog = false;

        this.agendaListe();

      } catch (error) {
        defaultMethods.dispatchError(this.$store);
      }
      this.loading = false;
    },
    addNewProgramme() {
      this.agendaData = {}
      this.appointmentAddDialog = true
    },
    updateRange() {
      this.events = [];
      // alert(JSON.stringify(this.Agenda));
      // console.log(JSON.stringify(this.Agenda));
      if (this.Agenda != "") {
        for (let i = 0; i < this.Agenda.length; i++) {
          // alert(JSON.stringify(this.Agenda.length));
          // alert(i);
          let program = [];
          program = this.Agenda[i];
          // alert(JSON.stringify(program));
          const progDate = program.date;
          const subject = program.subject ? program.subject : "";
          const rememberMinutes = program.rememberMinutes
            ? program.rememberMinutes
            : 0;
          const emails = program.emails;
          const assignTo = defaultMethods.getNameList(program.assignTo);
          // const startPeriod = program.period ? program.period.start : "";
          // const endPeriod = program.period ? program.period.end : "";
          //alert(program.period.start)
          if (program.color == "orange") {
            // alert(program.period);
            // this.date = new Date(`${program.date}`);
            // this.dates = new Date(`${program.date}`);
            const startHours = program.period.start.split(":");
            const endHours = program.period.end.split(":");
            // this.date.setHours(startHours[0]);
            // this.date.setMinutes(startHours[1]);

            const date = new Date(`${program.date}`);
            const dates = new Date(`${program.date}`);
            date.setHours(startHours[0]);
            date.setMinutes(startHours[1]);
            dates.setHours(endHours[0]);
            dates.setMinutes(endHours[1]);

            this.events.push({
              name: program.reason ? program.reason : "",
              location: program.location ? program.location : "",
              assignTo: assignTo ? assignTo : [],
              date: progDate,
              start: date,
              end: dates,
              subject: subject,
              rememberMinutes: rememberMinutes,
              emails: emails,

              endPeriod: dates,
              participants: program.participants,
              // hour: program.hour,
              startPeriod: date,
              hour: program.hour,
              done: program.done,
              returnObservation: program.returnObservation,
              color: program.color,
              timed: true,
              _id: program._id,
            });
          } else {
            // this.date = new Date(`${program.date}`);
            const date = new Date(`${program.date}`);
            const dates = new Date(`${program.date}`);
            const hours = program.hour.split(":");
            // alert(hours[0]);
            date.setHours(hours[0]);
            date.setMinutes(hours[1]);
            dates.setHours(hours[0]);
            dates.setMinutes(hours[1]);

            this.events.push({
              name: program.reason ? program.reason : "",
              location: program.location ? program.location : "",
              assignTo: assignTo ? assignTo : [],
              date: progDate,
              start: date,
              end: dates,
              subject: subject,
              rememberMinutes: rememberMinutes,
              emails: emails,

              endPeriod: dates,
              participants: program.participants,
              // hour: program.hour,
              startPeriod: date,
              hour: program.hour,
              done: program.done,
              returnObservation: program.returnObservation,
              color: this.colors[this.rnd(0, this.colors.length - 1)],
              timed: true,
              _id: program._id,
            });
            // alert(date);
          }
          // if (program.color == "orange") {
          //   alert(
          //     JSON.stringify({
          //       name: program.reason ? program.reason : "",
          //       location: program.location ? program.location : "",
          //       assignTo: assignTo ? assignTo : [],
          //       date: progDate,
          //       start: date,
          //       end: dates,
          //       subject: subject,
          //       rememberMinutes: rememberMinutes,
          //       emails: emails,

          //       endPeriod: program.endOriginal,
          //       participants: program.participants,
          //       // hour: program.hour,
          //       startPeriod: program.startOriginal,
          //       hour: program.hour,
          //       done: program.done,
          //       returnObservation: program.returnObservation,
          //       color: program.color,
          //       timed: true,
          //       _id: program._id,
          //     })
          //   );
          // }

          // this.events = this.newEvents;
          // alert(JSON.stringify(this.events));
        }
      }
      // const min = new Date(`${start.date}T00:00:00`);
      // const max = new Date(`${end.date}T23:59:59`);
      // const days = (max.getTime() - min.getTime()) / 86400000;
      // const eventCount = this.rnd(days, days + 20);
    },
    // decotique(program) {
    // alert(JSON.stringify(program.color));
    // },
    rnd(a, b) {
      return Math.floor((b - a + 1) * Math.random()) + a;
    },

    reaction(item) {
      if (item == "call") {
        this.showcall = true;
        this.showPriority = false;
        this.showRdv = false;
        this.SizeDrawers = "300px";
      }
      if (item == "priority") {
        this.showPriority = true;
        this.showRdv = false;
        this.showcall = false;
        this.SizeDrawers = "300px";
      }
      if (item == "rdv") {
        this.showRdv = true;
        this.showPriority = false;
        this.showcall = false;
        this.SizeDrawers = "300px";
      }
      if (item == "close") {
        this.showRdv = false;
        this.showPriority = false;
        this.showcall = false;
        this.SizeDrawers = "0px";
        location.reload();
      }
    },
    onScroll(e) {
      if (typeof window === "undefined") return;
      const top = window.pageYOffset || e.target.scrollTop || 0;
      this.fab = top > 20;
    },
    toTop() {
      this.$vuetify.goTo(0);
    },
    logoutMethods() {
      logout();
    },
    async onUpdatedUserProfile() {
      // update

      try {
        const formData = new FormData();
        if (this.idPicture) {
          formData.append("idPicture", this.idPicture);
        }
        formData.append("lastName", this.profile.lastName);
        formData.append("firstName", this.profile.firstName);
        formData.append("email", this.profile.email);
        formData.append("phone", this.profile.phone);
        formData.append("currentPosition", this.profile.currentPosition);
        formData.append("agency", this.profile.agency);
        formData.append("username", this.profile.username);
        if (this.profile.passwords) {
          formData.append("oldPassword", this.profile.oldPassword);
          formData.append("password", this.profile.passwords);
        }

        await updateUsers({
          schema: formData,
        });

        defaultMethods.dispatchSuccess(
          this.$store,
          messages.updatedSuccessfully("L'utilisateur")
        );
        this.logoutMethods();
      } catch (error) {
        alert(error);
      }
    },
    agendaListe() {
      try {
        return new Promise((resolve, reject) => {
          this.getAgenda({ my: this.showAllFil })
            .then((res) => {
              resolve(true);
              this.updateRange();
              console.log(res);
            })
            .catch((error) => {
              // alert(error);
              reject(error);
            });
        });
      } catch (error) {
        defaultMethods.dispatchError(
          this.$store,
          messages.failedToLoad("les dossiers")
        );
      }
    },
    async initpriority() {
      this.loading = true;
      // alert(JSON.stringify(this.UserProfile));
      try {
        // await this.getAgenda(this.UserProfile._id);
        await this.getPriority();
        await this.getCallList();
        await this.getRdvList();
        await this.getFiles({ withoutPeriod: true });
        await this.getUsers()
      } catch (error) {
        defaultMethods.dispatchError(
          this.$store,
          messages.failedToLoad("les dossiers")
        );
      }
      this.loading = false;
    },
  },
};
</script>

<style>
.appBar {
  color: #fff !important;
  border: 0 solid black;
  background: #fff !important;
  /* border-bottom: 0.3px solid #f4f7fe !important; */
  /* background: -webkit-linear-gradient(to right, #4dd0e1, #0482fb);
  background: linear-gradient(to right, #4dd0e1, #0482fb); */
}

.firstBar {
  background-color: #fff !important;
  margin-bottom: 10px !important;
  border-bottom: 0.3px solid #f4f7fe !important;
  max-height: 70px;
}

.leftBar {
  border: 1 solid #0482fb;
  height: 100% !important;
  background: #fff;
  /* background: -webkit-linear-gradient(to bottom, #4dd0e1, #0482fb, #0482fb);
  background: linear-gradient(to bottom, #4dd0e1, #0482fb, #0482fb); */
}

.degrader {
  background: #0482fb !important;
  /* background: -webkit-linear-gradient(to left, #4dd0e1, #0482fb, #0482fb);
  background: linear-gradient(to left, #4dd0e1, #0482fb, #0482fb); */
}

.toggleBtn {
  margin-left: 10px;
}

#create .v-speed-dial {
  position: absolute;
}

.sheetTitle {
  border-top: 0px solid #f4f7fe !important;
  padding: 10px;
  justify-content: space-between;
  align-items: center;
  align-content: center;
  display: flex;
  border-bottom: 0.3px solid #f4f7fe !important;
  position: sticky;
  position: -webkit-sticky;
  /* for Safari */
  top: 0em;
  z-index: 2;
  background-color: #0482fb !important;
  overflow: hidden !important;
}

.sheetTitle:hover {
  border-top: 0px solid #f4f7fe !important;
  padding: 10px;
  justify-content: space-between;
  align-items: center;
  align-content: center;
  display: flex;
  border-bottom: 0.3px solid #f4f7fe !important;
  position: sticky;
  position: -webkit-sticky;
  /* for Safari */
  top: 0em;
  z-index: 2;
  background-color: #0482fb !important;
}

.titleAlert {
  color: #fff;
  font-size: 15px;
  font-weight: bold;
  margin-left: 8px;
  justify-content: center;
  align-items: center;
  align-content: center;
}

.listLibele {
  font-size: 15px !important;
  font-weight: bold !important;
  color: #0482fb !important;
  margin-left: 0px;
}

.alertList {
  border-left: 5px solid #4caf50 !important;
  margin-bottom: 10px;
  margin-left: 0px !important;
  padding: 5px;
  font-size: 12px;
  border-radius: 0px !important;
  background-color: #fff !important;
  border-bottom: 1px solid #f4f7fe;
  overflow: hidden !important;
}

.alertLists {
  border-left: 5px solid #fb8c00 !important;
  margin-bottom: 10px !important;
  margin-left: 0px !important;
  padding-left: 10px;
  font-size: 12px;
  border-radius: 0px !important;
  background-color: #fff !important;
  border-bottom: 1px solid #f4f7fe;
  overflow: hidden !important;
}

.alertListe {
  border-left: 5px solid #f44336 !important;
  margin-bottom: 10px !important;
  margin-left: 0px !important;
  padding-left: 10px;
  font-size: 12px;
  border-radius: 0px !important;
  background-color: #fff !important;
  border-bottom: 1px solid #f4f7fe;
  overflow: hidden !important;
}

#create .v-btn--floating {
  position: relative;
}

.fixed-bar {
  position: sticky !important;
  position: -webkit-sticky !important;
  /* for Safari */
  z-index: 22 !important;
  top: 0em;
  /* border-bottom: 0.3px solid #f4f7fe !important; */
}

.fixed-bars {
  position: sticky !important;
  position: -webkit-sticky !important;
  /* for Safari */
  z-index: 20 !important;
  top: -80em;
  /* border-bottom: 0.3px solid #f4f7fe !important; */
}

.headCalender {
  margin-bottom: 30px;
  margin-top: 20px;
}

.textColor {
  color: #7d8da1 !important;
  font-weight: bolder;
}
.textColor-active{
  background-color: #848bc82e !important;
  color: #0482fb !important;
}

.textColor2 {
  color: #0482fb !important;
  font-weight: bolder;
}

.textColor4 {
  background-color: #0482fb !important;
}

.textColor3 {
  background-color: #4dd0e1 !important;
}

.clickable {
  -webkit-app-region: no-drag;
}

.pageTitle {
  font-size: 2.125rem !important;
  font-weight: bold !important;
  color: #0482fb;
}

::-webkit-scrollbar {
  width: 10px;
  height: 15px;
  margin-left: 1500px !important;
}

::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  border-radius: 10px;
}

::-webkit-scrollbar-thumb {
  border-radius: 10px;
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.5);
  background-color: #0482fb !important;
}

.tab_color {
  border-top: 5px solid #0482fb !important;
  color: #0482fb !important;
}

.illustrationCenter {
  justify-content: center;
  align-items: center;
  align-content: center;
  margin-top: 400;
  display: flex;
  margin-top: 20px;
}

.tab {
  border-bottom: 0px solid #fff !important;
}

.w-100 {
  width: 100%;
}
</style>
